import React, { Component } from 'react';
import './BirdsEyeView.css';
import UrlHelper from '../core/UrlHelper';
import UnitMarker from './UnitMarker';
import ParameterErrors from '../errors/ParameterErrors';
import Dialog from './Dialog';
import ZoomableDragable from './ZoomableDragable';
import DirectionalButtons from './DirectionalButtons';
import getAbsolute from '../ui_core/getAbsolute';
import Once from '../core/Once';
import FrequencyLimitedCallback from '../core/FrequencyLimitedCallback';
import Urls from '../urls/Urls';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import HashSource from '../core/HashSource';
import GoogleAnalytics from '../google/GoogleAnalytics';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';
const{throwNotProvided}=ParameterErrors;
export default class BirdsEyeView extends Component {
	constructor(props){
		super(props);
		const {showPlotMoreInformation, updateExternalZoomSource, favouritesRef, zoomMax, zoomMin,
		 addFavourite, removeFavourite, showOutside360, enterHouse, showBrochureGenerationDialog,
		 plotMenuRef, showPlotDetailedInformation, getConfiguration}= props;
		 this._getConfiguration = getConfiguration;
		if(!showPlotMoreInformation)throwNotProvided('showPlotMoreInformation');
		if(!updateExternalZoomSource)throwNotProvided('updateExternalZoomSource');
		if(!updateExternalZoomSource)throwNotProvided('updateExternalZoomSource');
		if(!favouritesRef)throwNotProvided('favouritesRef');
		if(zoomMax===undefined||zoomMax===null)throwNotProvided('zoomMax');
		if(zoomMin===undefined||zoomMin===null)throwNotProvided('zoomMin');
		this._zoomMin = zoomMin;
		this._zoomMax = zoomMax;
		this._favouritesRef=favouritesRef;
		this._showPlotDetailedInformation= showPlotDetailedInformation;
		this._updateExternalZoomSource=updateExternalZoomSource;
		this._callbackShowPlotMoreInformation = showPlotMoreInformation;
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowOutside360=showOutside360;
		this._callbackEnterHouse = enterHouse;
		this._callbackShowBrochureGenerationDialog = showBrochureGenerationDialog;
		this.state ={siteJson:null};
		this._birdsEyeViewAnglesAscending = [];
		this.setVisible= this.setVisible.bind(this);
		this._element = React.createRef();
		this._plotMenuRef = plotMenuRef;
		this._zoomableDragableRef=React.createRef();
		this._markersRef=React.createRef();
		this._dragDropMarkerRef=React.createRef();
		this._directionButtonsRef=React.createRef();
		this._createMarkers = this._createMarkers.bind(this);
		this._clear= this._clear.bind(this);
		this._clearPlotMarkers = this._clearPlotMarkers.bind(this);
		this._handleClickPlotMarker = this._handleClickPlotMarker.bind(this);
		this._setMarkersVisible = this._setMarkersVisible.bind(this);
		this._handleHoverPlotMarker = this._handleHoverPlotMarker.bind(this);
		this._handleShowPlotMoreInformation = this._handleShowPlotMoreInformation.bind(this);
		this.resize = this.resize.bind(this);
		this._handleClickLeft = this._handleClickLeft.bind(this);
		this._handleClickRight = this._handleClickRight.bind(this);
		this._handleEnterHouse = this._handleEnterHouse.bind(this);
		this._showPlotMenu = this._showPlotMenu.bind(this);
		this._handleShowBrochureGenerationDialog= this._handleShowBrochureGenerationDialog.bind(this);
		this._getShouldFitToHeight= this._getShouldFitToHeight.bind(this);
		this._getAspectRatio= this._getAspectRatio.bind(this);
		this._getNearestSiteJsonOutside360 = this._getNearestSiteJsonOutside360.bind(this);
		this._setDragDropMarkerPosition= this._setDragDropMarkerPosition.bind(this);
		this._updateTutorialMessages= this._updateTutorialMessages.bind(this);
		this.getMarkerPositionForPlotNumber= this.getMarkerPositionForPlotNumber.bind(this);
		this._initializeNearestOutside360PixelMappingsIfNecessary= this._initializeNearestOutside360PixelMappingsIfNecessary.bind(this);
		this._isDesktopAndShouldShowPlotDetailedInformationInstead= this._isDesktopAndShouldShowPlotDetailedInformationInstead.bind(this);
		this._frequencyLimitedCallbackGetNearestSiteJsonOutside360= new FrequencyLimitedCallback({frequencyHz:6});
		this._fittedToHeight = false;
		this._zoomedOutOnFirstFilterAfterFittingToHeight = false;
		this.load = this.load.bind(this);
		this._load = this._load.bind(this);
		this.setZoom= this.setZoom.bind(this);	
		const configuration = this._getConfiguration();
		this._birdsEyeViewIndex = 0;//configuration.defaultAerialIndex!==undefined?configuration.defaultAerialIndex:0;
		this._currentSiteJsonBirdsEyeViewsBirdsEyeView = null;
		this._nearestOutside360UniqueId = null;
		this._showPlotMenuOnce = new Once(this._showPlotMenu);
		this.state={unitMarkers:[], visible:true, showPlotMarkers:false};
		Tutorials.addEventListener('update', this._updateTutorialMessages);
	}
	componentDidMount(){
		this._resizeWatcherParentElement = new ResizeWatcher({element:this._element.current});
		this._resizeWatcherParentElement.addEventListener('resized', this.resize);
	}
	
	setVisible(value){
		this.setState({visible:value});
		if(value){
			this.resize();
		}
	}
	resize(){
			setTimeout(()=>{
			this._zoomableDragableRef.current?._resize();
			}, 0);
	}
	setZoom(value){
		return new Promise((resolve, reject)=>{
			this._zoomableDragableRef.current.setZoom(value).then(resolve).catch(reject);
		});
	}	
	load(params){
		const self = this;
		return new Promise((resolve, reject)=>{
			const {siteJson, unitsArray, showPlotMarkers, filtered}=params;
			if(siteJson===undefined||siteJson===null)throwNotProvided('siteJson');
			this.setState({showPlotMarkers:showPlotMarkers||showPlotMarkers===undefined||showPlotMarkers===null});
			this._siteJson = siteJson;
			this._unitsArray = unitsArray; 
			let zoomOut = false;
			if(filtered){
				if(!this._zoomedOutOnFirstFilterAfterFittingToHeight &&this._fittedToHeight){
					this._zoomedOutOnFirstFilterAfterFittingToHeight =true;
					zoomOut = true;
				}
			}
			this._load(zoomOut).then(resolve).catch(reject);
		});
	}
	getMarkerPositionForPlotNumber(plotNumber){
		const unit = this._siteJson.units.getPlotByNumber(plotNumber).unit;
		let markerPosition = unit.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex(this._birdsEyeViewIndex);
		const positionAsPercentages = markerPosition?[markerPosition.x, markerPosition.y]:[50,50];
		const element = this._markersRef.current;
		const elementAbsolutePosition = getAbsolute(element);
		const absolutePositionArray = [(positionAsPercentages[0]*element.offsetWidth/100)+elementAbsolutePosition.left, (positionAsPercentages[1]*element.offsetHeight/100)+elementAbsolutePosition.top+40];
		return absolutePositionArray;
	}
	_load(zoomOut){
		return new Promise((resolve, reject)=>{
			this._cancelCurrentLoadOperation&&this._cancelCurrentLoadOperation();
			let cancelled = false;
			this._cancelCurrentLoadOperation =()=>{cancelled = true;};
			const birdsEyeViews = this._siteJson.birdsEyeViews.getArray();
			//birdsEyeViews.sort((a, b)=>a.angle<b.angle);
			if(this._birdsEyeViewIndex<0)this._birdsEyeViewIndex+=birdsEyeViews.length;
			this._birdsEyeViewIndex = this._birdsEyeViewIndex%birdsEyeViews.length;
			const siteJsonBirdsEyeViewsBirdsEyeView = birdsEyeViews[this._birdsEyeViewIndex];
			if(siteJsonBirdsEyeViewsBirdsEyeView===undefined||siteJsonBirdsEyeViewsBirdsEyeView===null)throwNotProvided('siteJsonBirdsEyeViewsBirdsEyeView');
			this._currentSiteJsonBirdsEyeViewsBirdsEyeView = siteJsonBirdsEyeViewsBirdsEyeView;
			const relativePath = siteJsonBirdsEyeViewsBirdsEyeView.imageRelativePath;
			const imgUrl =UrlHelper.makeSureSlashOnEnd(Urls.getAssetsForSite(this._getConfiguration().siteSlug))+
				UrlHelper.removeStartSlash(relativePath);
			this._clear();
			const afterLoadImg = ()=>{
				if(cancelled){
					resolve();
					return;
				}
				if(!this._createdMarkers)
					this._createMarkers(this._siteJson, this._unitsArray, 
					siteJsonBirdsEyeViewsBirdsEyeView.angle);
				this._setMarkersVisible(this._unitsArray);
				this._cancelCurrentLoadOperation=null;
				if(zoomOut){
					this.setZoom(1);
				}
				this._initializeNearestOutside360PixelMappingsIfNecessary().then(resolve).catch(reject);
			};
			const zoomableDragable = this._zoomableDragableRef.current;
			if(zoomableDragable.imgUrl ===imgUrl){
				afterLoadImg();
				return;
			}
			const fitToHeight = this._getShouldFitToHeight();
			this._fittedToHeight = fitToHeight;
			zoomableDragable.load(imgUrl, fitToHeight).then(afterLoadImg).catch(reject);
		});
	}
	_initializeNearestOutside360PixelMappingsIfNecessary(){
		return new Promise((resolve, reject)=>{
			const nearestOutside360PixelMappings  = this._currentSiteJsonBirdsEyeViewsBirdsEyeView?.nearestOutside360PixelMappings;
			if((!nearestOutside360PixelMappings)||nearestOutside360PixelMappings.initialized){
				resolve();
				return;
			}
			nearestOutside360PixelMappings.initialize().then(resolve).catch(reject);
		});
	}
	_getShouldFitToHeight(){
		return (this._getAspectRatio()<0.9)||(this._element.current.offsetHeight<400);
	}
	_handleEnterHouse (plot){
		this._callbackEnterHouse(plot);
	}
	_handleShowPlotMoreInformation(plot, plotMoreInformationType){
		this._callbackShowPlotMoreInformation(plot, plotMoreInformationType);
		this._plotMenuRef.current.hide();
	}
	_setMarkersVisible(){
		const unitMarkers = this.state.unitMarkers;
		unitMarkers.forEach(unitMarker=>unitMarker.ref.current.filteredOut
		=this._unitsArray.indexOf(unitMarker.ref.current.unit)<0);
	}
	_clear(){
		this._clearPlotMarkers();
	}
	_clearPlotMarkers(){
		this.setState({unitMarkers:[]});
		this._createdMarkers = false;
	}
	_getAspectRatio(){
		const element = this._element.current;
		if(element===undefined||element=== null)return null;
		return element.offsetWidth/element.offsetHeight;
	}
	_handleClickPlotMarker(e){
		Tutorials.hasExpandedPlotMenu=true;
		this._showPlotMenuOnce.trigger(e);
	}
	_handleHoverPlotMarker(e){
		if(!e.hovering)return;
		Tutorials.hasExpandedPlotMenu=true;
		if(this._isDesktopAndShouldShowPlotDetailedInformationInstead()){
				return;
		}
		if(this._getConfiguration().showPlotMenuOnClickInsteadOfHover){
			return;
		}
		this._showPlotMenuOnce.trigger(e);
	}
	_isDesktopAndShouldShowPlotDetailedInformationInstead(){
		return !window.isMobile &&this._getConfiguration().showPlotDetailedInformationOnDesktopClickInsteadOfHover;
	}
	_showPlotMenu(e){
		const marker = e.marker;
		GoogleAnalytics.logEvent('clickedUnitMarkerOnAerial', {unitId:marker.unit.id});
		if(this._isDesktopAndShouldShowPlotDetailedInformationInstead()){
			const plot = marker.unit.plots[0];
			this._showPlotDetailedInformation(plot);
			return;
		}
		const showPlotMenuOnClickInsteadOfHover = this._getConfiguration().showPlotMenuOnClickInsteadOfHover;
		this._plotMenuRef.current.show({position:e.markerPosition,
		getMouseInSourceBounds:marker.getMouseInBounds, untilClickOff:showPlotMenuOnClickInsteadOfHover,
			siteJson:this._siteJson, unit:marker.unit, plot:marker.unit.plots[0] }).catch(console.error);
	}
	_createMarkers(siteJson, unitsArray, angle){
		const unitMarkers = this.state.unitMarkers;
		for(var i=0; i<unitsArray.length; i++){
			const unit = unitsArray[i];
			if(unit.allPlotsAffordable)continue;
			const markerPosition = unit.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithAngle(angle);
			if(!markerPosition)continue;
			const unitMarker=(<UnitMarker key={HashSource.next()} ref={React.createRef()}
			onClick={this._handleClickPlotMarker} onHover={this._handleHoverPlotMarker}
				siteJson={siteJson} unit={unit} position={markerPosition}></UnitMarker>);
			unitMarkers.push(unitMarker);
			if(i===0)
				this._updateTutorialMessages(unitMarker);
		}
		this._createdMarkers=true;
		this.setState({unitMarkers:unitMarkers});
	}
	_updateTutorialMessages(unitMarker){
		this. _tutorialMessageOnUnitMarker?.dispose();
		this._tutorialMessageLeftRightButton?.dispose();
		setTimeout(()=>{
			this. _tutorialMessageOnUnitMarker?.dispose();
			const unitMarker = this.state.unitMarkers[0];
			if(((Tutorials.showStep2&&!Tutorials.hasExpandedPlotMenu)||Tutorials.showStep7)&&(!Tutorials.plotMenuShowing)&&unitMarker?.ref?.current&&Tutorials.showing){
				this._tutorialMessageOnUnitMarker = new TutorialMessage({
					message:Tutorials.showStep7?'View plot again':'View plot', elementOn:unitMarker.ref.current._element.current, 
					className:'tutorial-message-view-favourites',
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageOnUnitMarker);
			}
			this._tutorialMessageLeftRightButton?.dispose();
			if(this._directionButtonsRef.current&&Tutorials.showing&&!Tutorials.hasClickedBirdsEyeViewLeftOrRightButton){
				this._tutorialMessageLeftRightButton = new TutorialMessage({
					message:'Rotate view with these buttons',
					className:'tutorial-message-birds-eye-view-directional-buttons',					
					elementOn:this._directionButtonsRef.current._elementRef.current,						
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
						this._tutorialMessageLeftRightButton?.dispose();
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageLeftRightButton);
			}
		});
	}
	_handleClickLeft(){
		Tutorials.hasClickedBirdsEyeViewLeftOrRightButton = true;
		this._tutorialMessageLeftRightButton?.dispose();
		this._birdsEyeViewIndex--;
		this._load().catch(console.error);
	}
	_handleClickRight(){
		Tutorials.hasClickedBirdsEyeViewLeftOrRightButton = true;
		this._tutorialMessageLeftRightButton?.dispose();
		this._birdsEyeViewIndex++;
		this._load().catch(console.error);
	}
	_handleShowBrochureGenerationDialog(params){
		this._callbackShowBrochureGenerationDialog(params);
	}
	onDrop(params){
		this._setDragDropMarkerPosition(null);
		GoogleAnalytics.logEvent('usedDragDropMan', {});
		this._callbackShowOutside360({outside360UniqueId:this._nearestOutside360UniqueId});
	}
	onDragging(params){
		this._frequencyLimitedCallbackGetNearestSiteJsonOutside360.trigger(()=>{
			const siteJsonOutside360 = this._getNearestSiteJsonOutside360(params.x, params.y);
		});
	}
	_setDragDropMarkerPosition(markerPosition){
		const dragDropMarkerElement = this._dragDropMarkerRef.current;
		if(!markerPosition){
			dragDropMarkerElement.style.display=`none`;
			return;
		}
		dragDropMarkerElement.style.left=`${markerPosition.x*100}%`;
		dragDropMarkerElement.style.top=`${markerPosition.y*100}%`;
		dragDropMarkerElement.style.display=`block`;
	}
	_getNearestSiteJsonOutside360(x, y){
		const nearestOutside360PixelMappings = this._currentSiteJsonBirdsEyeViewsBirdsEyeView?.nearestOutside360PixelMappings;
		if((!nearestOutside360PixelMappings)||(!nearestOutside360PixelMappings.initialized)){
			this._nearestOutside360UniqueId=null;
			return null;
		}
		const unitMarkers = this._markersRef.current;
		if(!unitMarkers){
			this._nearestOutside360UniqueId=null;
			return;
		}
		const unitMarkersAbsolutePosition = getAbsolute(this._markersRef.current);
		x = x - unitMarkersAbsolutePosition.left;
		y = y-unitMarkersAbsolutePosition.top;
		const xProportion = x/unitMarkers.offsetWidth;
		const yProportion = y/unitMarkers.offsetHeight;
		this._nearestOutside360UniqueId = nearestOutside360PixelMappings.getValueFromProportions(xProportion, yProportion);
		const markerPosition = this._currentSiteJsonBirdsEyeViewsBirdsEyeView.getMarkerPositionForOutside360(this._nearestOutside360UniqueId);
		this._setDragDropMarkerPosition(markerPosition);
	}
	render() {
		let innerClassName = "inner";
		const configuration = this._getConfiguration();
		const birdsEyeViewMarkers = this._siteJson?.birdsEyeViews.getArray();
		const hasMoreThanOneBirdsEyeView = birdsEyeViewMarkers!==undefined&&birdsEyeViewMarkers!==null&&(birdsEyeViewMarkers.length>1);
		const className = "birds-eye-view "+(this.state.visible?'visible ':'')+
			(this.state.showPlotMarkers?'show-unit-markers ':'')
			+(configuration.showFadedFilteredOutPlots?'show-filtered-out-plots':'hide-filtered-out-plots');
		this._updateTutorialMessages();
		return (<div className={className} ref={this._element}>
				{hasMoreThanOneBirdsEyeView?(<DirectionalButtons ref={this._directionButtonsRef}
					onClickLeft={this._handleClickLeft} 
					onClickRight={this._handleClickRight} rightButtonClasses={['button-rotate-aerial-right']}/>):null}<ZoomableDragable ref={this._zoomableDragableRef} parentElementRef={this._element} getContainerAspectRatio={this._getAspectRatio} updateExternalZoomSource={this._updateExternalZoomSource} zoomMax={this._zoomMax} zoomMin={this._zoomMin}>
				<div className="markers" ref={this._markersRef}>
					<div className="unit-markers">
						{this.state.unitMarkers}
					</div>
					<img className="drag-drop-marker" src={Urls.getAssetsForSite(configuration.siteSlug)+'icons/UI_Button_Walkmode_DropPoint.png'} ref={this._dragDropMarkerRef}></img>
				</div>
			</ZoomableDragable>
		</div>)
	}
}
